/* Keep Arabic journeys in Arabic when a theme section contains unlocalized internal links.
   Restrict rewriting to customer-facing Shopify routes; do not touch checkout, external or app links. */
(() => {
  if (!(document.documentElement.lang || '').toLowerCase().startsWith('ar')) return;
  let root = window.Shopify?.routes?.root || '/ar/';
  if (!/^\/ar(?:\/|$)/.test(root)) root = '/ar/';
  const prefix = root.replace(/\/$/, '');
  const localizedPath = /^\/(?:pages|products|collections|blogs|cart|search|policies)(?:\/|$)/;
  // Shopify's translated handles are distinct from English handles.
  // These aliases are taken from this store's current published Arabic translations.
  const translatedHandles = Object.freeze({
    '/pages/shop': '/pages/تسوق',
    '/pages/ingredients': '/pages/المكونات',
    '/pages/faq': '/pages/الأسئلة-الشائعة',
    '/pages/science': '/pages/علم',
    '/blogs/journal': '/blogs/مجلة',
    '/blogs/news': '/blogs/أخبار',
  });
  const fix = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//')) return;
    const url = new URL(href, location.origin);
    // Leave explicitly English links untouched; repair known old /ar/ handles too.
    if (/^\/en(?:\/|$)/.test(url.pathname)) return;
    const isArabic = /^\/ar(?:\/|$)/.test(url.pathname);
    const basePath = isArabic ? url.pathname.slice(3) : url.pathname;
    if (!isArabic && !localizedPath.test(basePath)) return;
    const translatedPath = translatedHandles[basePath];
    if (isArabic && !translatedPath) return;
    const destination = prefix + (translatedPath || basePath) + url.search + url.hash;
    if (href !== destination) link.setAttribute('href', destination);
  };
  document.querySelectorAll('a[href^="/"]').forEach(fix);
  document.addEventListener('click', event => fix(event.target instanceof Element ? event.target.closest('a[href^="/"]') : null), true);
})();
